import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { SentryErrorHandler } from '../sentry.errorhandler';
import { JatakkResponse, Title } from './models';
import { Result } from './result';

@Injectable({ providedIn: 'root' })
export class YesnoService {
  constructor(
    private http: HttpClient,
    private sentryErrorHandler: SentryErrorHandler,
  ) {}

  public doWeWantThis(isbn: string): Observable<Result> {
    return this.http.get<JatakkResponse>(this.constructUrl(isbn)).pipe(
      switchMap((jatakkResponse: JatakkResponse) => {
        const isAnyTitleWithCopiesWanted = this.isAnyTitleWithCopiesWanted(
          jatakkResponse.titles,
        );
        return isAnyTitleWithCopiesWanted ? of(Result.Yes) : of(Result.No);
      }),
      catchError(this.handleErrorAndReturnDefault.bind(this)),
    );
  }

  private constructUrl(isbn: string): string {
    return `${environment.apiRoot}/data/mode=check?isbn=${isbn}`;
  }

  private isAnyTitleWithCopiesWanted(titles: Title[]): boolean {
    return titles.some((title) => title.copieswanted > 0);
  }

  private handleErrorAndReturnDefault(err: unknown): Observable<Result> {
    this.sentryErrorHandler.handleError(err);
    return of(Result.Yes);
  }
}
